import { Modal } from "react-bootstrap";
import Button from "../molecules/Button";
import styles from './modal.module.css';
export const CustomModal = ({
  title,
  isOpen,
  onClose,
  onConfirm,
  children,
}) => {
  return (
    <Modal show={isOpen} onHide={onClose}>
    <Modal.Header closeButton className={styles.background}>
      <Modal.Title className="text-white">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className={styles.modalSize}>{children}</Modal.Body>
    <Modal.Footer className={styles.background}>
      <button onClick={onClose} className={`${styles['btn']} ${styles['btn-primary']} mt-3`}>
        Cancel
      </button>
      <button onClick={onConfirm} className={`${styles['btn']} ${styles['btn-primary']} mt-3`}>
        Confirm
      </button>
    </Modal.Footer>
  </Modal>
  )
};
